import { useEffect, useState } from 'react';

export const useMatchMedia = (props) => {
  const { tabletBreakpoint, desktopBreakpoint } = props;
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  const matchTabletSizeHandler = (e) => {
    setIsTablet(e.matches);
  };

  const matchDesktopSizeHandler = (e) => {
    setIsDesktop(e.matches);
  };

  useEffect(() => {
    const matchTabletQueryList = window.matchMedia(`(min-width: ${tabletBreakpoint}px)`);
    const matchDesktopQueryList = window.matchMedia(`(min-width: ${desktopBreakpoint}px)`);
    matchTabletSizeHandler(matchTabletQueryList);
    matchDesktopSizeHandler(matchDesktopQueryList);

    if (matchTabletQueryList.addEventListener) {
      matchTabletQueryList.addEventListener('change', matchTabletSizeHandler);
    } else {
      matchTabletQueryList.addListener(matchTabletSizeHandler);
    }
    if (matchDesktopQueryList.addEventListener) {
      matchDesktopQueryList.addEventListener('change', matchDesktopSizeHandler);
    } else {
      matchDesktopQueryList.addListener(matchDesktopSizeHandler);
    }

    return () => {
      if (matchTabletQueryList.removeEventListener) {
        matchTabletQueryList.removeEventListener('change', matchTabletSizeHandler);
      } else {
        matchTabletQueryList.removeListener(matchTabletSizeHandler);
      }
      if (matchDesktopQueryList.removeEventListener) {
        matchDesktopQueryList.removeEventListener('change', matchDesktopSizeHandler);
      } else {
        matchDesktopQueryList.removeListener(matchDesktopSizeHandler);
      }
    };
  }, [desktopBreakpoint, tabletBreakpoint]);

  return {
    isTablet,
    isDesktop,
  };
};
